// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__11Wue","largestCol":"styles_largestCol__2h58y","smallestCol":"styles_smallestCol__3rf77"};